import { useEffect, useRef, useState } from "react";
import { useAuth } from "..";
import BottomSheet from "../../bottom-sheet/bottom-sheet";
import { UserListLocal } from "./add-account";
import { LogOut, UserPlus } from "lucide-react";
import { User } from "../types";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";

interface ModalCommentsPropsBottom {
    open: boolean;
    setOpen: (val: boolean) => void;
}
type getCommentsOrResponseType = "response" | "comment";

const AddAccountBottom: React.FC<ModalCommentsPropsBottom> = ({ open, setOpen }) => {
    const { t } = useTranslation();
    const openModalLikesRef = useRef<HTMLButtonElement | null>(null);
    const { addOtherAccount, logout } = useAuth();
    const [usersSessions, setUsersSessions] = useState<User[]>([]);
    const usersCount = usersSessions.length;

    const snapPoint =
        usersCount <= 1 ? 0.3 :
        usersCount <= 3 ? 0.5 :
        usersCount <= 5 ? 0.7 :
        0.9;
    
    useEffect(() => {
        const users = JSON.parse(Cookies.get('saved_users') ?? "[]");
        setUsersSessions(users); // Remove o return, pois `setState` não pode ser retornado
    }, []);


    // impede de voltar tela ao clicar em voltar com modal aberto
    useEffect(() => {
        if(open) window.history.pushState({ isModal: true }, "");
        else window.history.pushState({ isModal: false }, "");
    }, [open]);
    useEffect(() => {
        const handlePopState = (event: any) => {
            if (open) {
                setOpen(false); // Fecha o modal se o usuário voltou
            }
        };

        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, [open]);

    function handleAddAccount(){
        addOtherAccount();
        setOpen(false);
    }

    return (

        <BottomSheet snapPoints={[0, snapPoint, 1]} initialSnap={1} disableDrag setOpen={setOpen} open={open}>
            <div className="modal-light modal-dialog modal-dialog-likes modal-dialog-centered cover-mobile" style={{ overflow: "hidden" }}  role="document">
                <div className="modal-content modal-content-likes" id="modal-content-likes">
                    <div className="modal-header modal-header-comments">
                        {/* <h4 className={`modal-title ml-5`} id="modal-curtida">
                            {idCommentSelected ? (
                                <ChevronLeft onClick={backComment} className="back-comment chevron-comments-left" size="30" />
                            ): null}

                            {idCommentSelected ? "Respostas" : "Comentários"}
                        </h4> */}

                    </div>
                    
                    <div style={{ marginTop: 5 }}>
                        <UserListLocal clickItem={() => { setOpen(false); }}/>

                        <div className="">
                            <div className="line"></div>
                        </div>
                        
                        <div onClick={handleAddAccount} className='cursor-pointer btn-add-account-drop' style={{display: usersSessions.length < 5 ? "flex" : "none"}}>
                            <UserPlus/>
                            {t("user.addAccount")}
                        </div>
    
                        <div className="user-select-none cursor-pointer btn-exit-drop" onClick={() => logout()}>
                            <div className="img-switch">
                                <LogOut data-feather="log-out"/>
                            </div>
                            <p style={{margin: 0}}>Sair</p>
                        </div>
                    </div>
                </div>

            </div>

            <button className="d-none" ref={openModalLikesRef} data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target={"#modal-comments"}>a</button>
        </BottomSheet>
    );
};

export default AddAccountBottom;
